import FieldNames from '../defaults/FieldNames.json';
import {formatDateForDisplay} from './DateHelper';


// Used for the Basic Filters and the project name dropdown on the Action Info screen
export const getProjectNameDateIdentifier = (featureObj, isProject) => {
  let identifier = "N/A";
  let feature = featureObj?.attributes ?? featureObj;
  if(!feature)
  {
    return identifier;
  }

  let projectName = isProject ? FieldNames.projectFields.name : FieldNames.featureFields.projectName;
  let projectID = isProject ? FieldNames.projectFields.id : FieldNames.featureFields.projectID;

  identifier = `${feature[projectID]} - ${feature[projectName]}`;
  if(feature[FieldNames.projectFields.isFirePerimeter] === FieldNames.yesNo.yes && feature[FieldNames.projectFields.fireDiscoveryDate])
  {
    identifier += ` - ${formatDateForDisplay(feature[FieldNames.projectFields.fireDiscoveryDate])}`;
  }
  if(feature[FieldNames.projectFields.isFirePerimeter] === FieldNames.yesNo.yes && feature[FieldNames.projectFields.fireCode])
  {
    identifier += ` - ${feature[FieldNames.projectFields.fireCode]}`;
  }

  return identifier;
}
